import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';

import { ROUTES } from '../../../constants';

const SHARED_HEADER_SCRIPT_ID = 'shared-header-script';

// MAX serves the bundle itself (same origin as this app), and the component
// is fully self-contained: it fetches its own data (auth, menus, colors...)
// from MAX's API via the max_api_token cookie. No props to wire up.
const loadSharedHeaderScript = (lang: string) => {
  if (document.getElementById(SHARED_HEADER_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = SHARED_HEADER_SCRIPT_ID;
  script.src = `${process.env.REACT_APP_HOST}/shared-components-library/standalone-header.js`;
  script.setAttribute('data-lang', lang);
  document.body.appendChild(script);
};

export const Header = (): JSX.Element => {
  const matchWithAuthPage = useRouteMatch({
    path: ROUTES.LOGIN,
    strict: true,
    sensitive: true,
  });
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    loadSharedHeaderScript(language || 'fr');
  }, [language]);

  return (
    <div
      id="custom-header"
      data-popups-enabled="true"
      style={matchWithAuthPage ? { display: 'none' } : undefined}
    />
  );
};

export default Header;
